import { memo, ReactElement } from 'react';
import { Colors } from '~/themes/colors';
import { Row } from '../Row';
import { Checkbox } from '../Checkbox';
import { Text } from '../Text';
import { TOptionValue } from './Types';

interface IChipOptionProps<T> extends TOptionValue<T> {
  isChecked?: boolean;
  onClick: (value: T, isChecked: boolean) => void;
}

const Component = <T extends string | number = string>({
  isChecked = false,
  label,
  value,
  onClick,
}: IChipOptionProps<T>) => (
  <Row
    backgroundColor={Colors.white}
    borderColor={isChecked ? Colors.secondary_500 : Colors.neutral_100}
    borderRadius={8}
    borderStyle="solid"
    borderWidth={1.5}
    cursor="pointer"
    data-testid={`multi-select-group.options.${label}`}
    role="button"
    tabIndex={0}
    onClick={() => onClick(value, !isChecked)}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick(value, !isChecked);
      }
    }}
    gap={8}
    paddingBlock={8}
    paddingInline={16}
  >
    <Checkbox checked={isChecked} />
    <Text fontSize={16}>{label}</Text>
  </Row>
);

export const ChipOption = memo(Component) as <T extends string | number = string>(
  props: IChipOptionProps<T>,
) => ReactElement;
